import React, { ReactElement } from 'react'
import { Layout1x1 } from './Layout1x1'
import { HorizontalSplit } from './HorizontalSplit'
import { VerticalSplit } from './VerticalSplit'
import { Layout1Left2Middle2Right } from './Layout1Left2Middle2Right'
import { Layout1Left2Right } from './Layout1Left2Right'
import { Layout1Top2Bottom } from './Layout1Top2Bottom'
import { Layout1Top3Bottom } from './Layout1Top3Bottom'
import { Layout2Top3Bottom } from './Layout2Top3Bottom'
import { Layout2x2 } from './Layout2x2'
import { Layout3x1 } from './Layout3x1'
import { Layout3x2 } from './Layout3x2'
import { DashboardLayoutStyle } from '../Types'

type LayoutOptionProps = {
    layoutType: DashboardLayoutStyle
    isSelected: boolean
    handleChange: () => void
}

export const determineLayout = (layout: DashboardLayoutStyle): ReactElement => {
    switch (layout) {
        case DashboardLayoutStyle.HorizontalSplit:
            return <HorizontalSplit />
        case DashboardLayoutStyle.Layout1Left2Middle2Right:
            return <Layout1Left2Middle2Right />
        case DashboardLayoutStyle.Layout1Left2Right:
            return <Layout1Left2Right />
        case DashboardLayoutStyle.Layout1Top2Bottom:
            return <Layout1Top2Bottom />
        case DashboardLayoutStyle.Layout1Top3Bottom:
            return <Layout1Top3Bottom />
        case DashboardLayoutStyle.Layout1x1:
            return <Layout1x1 />
        case DashboardLayoutStyle.Layout2Top3Bottom:
            return <Layout2Top3Bottom />
        case DashboardLayoutStyle.Layout2x2:
            return <Layout2x2 />
        case DashboardLayoutStyle.Layout3x1:
            return <Layout3x1 />
        case DashboardLayoutStyle.Layout3x2:
            return <Layout3x2 />
        case DashboardLayoutStyle.VerticalSplit:
            return <VerticalSplit />
        default:
            return <Layout1x1 />
    }
}

const LayoutOption: React.FC<LayoutOptionProps> = ({ layoutType, isSelected, handleChange }): ReactElement => (
    <div className={`layout-option ${isSelected && 'selected'}`}>
        <label>
            {determineLayout(layoutType)}
            <span className='visually-hidden'>
                <input type='radio' checked={isSelected} onChange={handleChange} />
            </span>
        </label>
    </div>
)

export default LayoutOption
